import React from "react";
import CollapseLayer from "./CollapseLayerPanel";
import mapHelper from "@mrwa/rime-replacement/infrastructure/mapHelper";
import { ServerSubLayer } from "@mrwa/rime-replacement/esriControls/layers/server";
import { CustomFileLayer } from "@mrwa/rime-replacement/esriControls/layers/customFileLayer";
import { isMatchingLayer } from "@mrwa/rime-replacement/esriControls/controls/layer/layerSynchronisationImpl";
import { LayerDetails } from "./LayerDetails";
import { v4 as uuidv4 } from "uuid";

export class LayerPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      uniqueIdentifier: null,
      expand: false,
      filteredGeometries: [],
    };

    this.gpsFileChanged = this.gpsFileChanged.bind(this);
    this.setLayers = this.setLayers.bind(this);
  }

  componentDidMount() {
    mapHelper.subscribe("layers", this.setLayers);
  }

  componentDidUpdate(prevProps) {
    if (this.props.playerContext !== prevProps.playerContext) {
      this.props.playerContext.onGpsFileChanged(this.gpsFileChanged);
    }
  }

  setLayers() {
    const excludedLayers = [];
    this.props.excludedLayers.forEach((excludedLayer) => {
      const { uniqueIdentifier, subLayerId } = excludedLayer;
      const rimeLayer = mapHelper.layers.find((layer) =>
        isMatchingLayer({ uniqueIdentifier, subLayerId }, layer)
      );
      excludedLayers.push(rimeLayer);
    });

    if (mapHelper.layers) {
      const layers = mapHelper.layers;
      const serverLayers = layers.filter(
        (rimeLayer) =>
          rimeLayer instanceof ServerSubLayer &&
          rimeLayer.layer.sourceJSON.geometryType === "esriGeometryPolyline" &&
          rimeLayer.visible &&
          !excludedLayers.includes(rimeLayer)
      );
      const customLayers = layers.filter(
        (rimeLayer) =>
          rimeLayer instanceof CustomFileLayer &&
          rimeLayer.layer.geometryType === "polyline" &&
          rimeLayer.visible
      );
      this.setState({
        filteredGeometries: [...serverLayers, ...customLayers],
      });
    }
  }

  gpsFileChanged() {
    this.setState({ uniqueIdentifier: uuidv4(), expand: true }, () => {
      this.setState({ expand: false });
    });
  }

  render() {
    return (
      <div key={this.state.uniqueIdentifier}>
        {this.state.filteredGeometries.map((layer) => (
          <CollapseLayer
            key={`${layer.layer.parent.uid}#${layer.id}` || `${layer.id}`}
            legend={layer.name}
            fileChanged={this.state.expand}
          >
            <LayerDetails
              playerContext={this.props.playerContext}
              layer={layer}
            />
          </CollapseLayer>
        ))}
      </div>
    );
  }
}
